module.exports = __webpack_public_path__ + "static/media/b2c-image-tmall.f206a9b3.png";